import ExamImage from "../../components/ExamImage";
import QuestionLayout from "../QuestionLayout";
import AudioPlayButton from "../AudioPlayButton";

export default function EarBinaryChoiceWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const audioValue = value._audio || {};

  function setAudioState(audioState) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      _audio: audioState
    });
  }

  function setAnswer(trialId, optionId) {
    if (mode !== "edit") return;

    onChange({
      ...value,
      [trialId]: optionId
    });
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      {/* 🔊 SHARED AUDIO */}
      {config.audio && (
        <div style={{ marginBottom: 18 }}>
          <AudioPlayButton
            src={config.audio}
            value={audioValue}
            onChange={setAudioState}
            mode={mode}
            maxListens={config.maxListens ?? 1}
          />
        </div>
      )}

      <div style={{ maxWidth: 640, color: "#111" }}>
        {config.trials.map((trial, i) => {
          const selected = value[trial.id];

          const part = feedback?.parts?.[trial.id];
          const isReview = mode === "review";

          return (
            <div key={trial.id} style={{ marginBottom: 28 }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "28px auto",
                  alignItems: "flex-start",
                  columnGap: 12
                }}
              >
                {/* TRIAL NUMBER */}
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 16,
                    lineHeight: "1",
                    paddingTop: 4,
                    textAlign: "right"
                  }}
                >
                  {i + 1}.
                </div>

                {/* IMAGE + HIT BOXES */}
                <div style={{ position: "relative" }}>
                  <ExamImage
                    src={trial.image}
                    alt={`Trial ${i + 1}`}
                    style={{ width: 200, display: "block" }}
                  />

                  {trial.options.map(opt => {
                    const isSelected = selected === opt.id;

                    const isCorrect =
                      isReview &&
                      isSelected &&
                      part?.correct === true;

                    const isIncorrect =
                      isReview &&
                      isSelected &&
                      part?.correct === false;

                    return (
                      <div
                        key={opt.id}
                        onClick={() =>
                          setAnswer(trial.id, opt.id)
                        }
                        style={{
                          position: "absolute",
                          left: opt.x,
                          top: opt.y,
                          width: opt.w,
                          height: opt.h,
                          cursor:
                            mode === "edit"
                              ? "pointer"
                              : "default",
                          boxSizing: "border-box",

                          borderStyle: "solid",
                          borderWidth: isSelected ? 3 : 2,

                          borderColor: isReview
                            ? isCorrect
                              ? "#2e7d32"
                              : isIncorrect
                              ? "#c62828"
                              : "rgba(0,0,0,0.25)"
                            : isSelected
                            ? "#1e90ff"
                            : "rgba(0,0,0,0.25)",

                          background: isReview
                            ? isCorrect
                              ? "rgba(46,125,50,0.15)"
                              : isIncorrect
                              ? "rgba(198,40,40,0.15)"
                              : "transparent"
                            : isSelected
                            ? "rgba(30,144,255,0.15)"
                            : "transparent"
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            </div>

          );
        })}
      </div>
    </QuestionLayout>
  );
}
